package com.devi3east.bashbuddy.dashboard.ui

import com.devi3east.bashbuddy.features.events.common.data.models.Event
import com.devi3east.bashbuddy.features.events.common.data.models.Ticket
import com.devi3east.bashbuddy.prizeList.domain.models.Prize
import com.devi3east.bashbuddy.purchase.domain.models.Allocation
import com.devi3east.bashbuddy.purchase.domain.models.PurchaseUiModel

data class DashboardUiState(
    val isDashboardLoading: Boolean = false,
    val isPrizeListLoading: Boolean = false,
    val isTicketDetailLoading: Boolean = false,
    val isEditingPrize: Boolean = false,
    val errorMessage: String? = null,
    val eventList: List<Event> = emptyList(),
    val prizeList: List<Prize> = emptyList(),
    val ticketList: List<Ticket> = emptyList(),
    val purchaseList: List<PurchaseUiModel> = emptyList(),
    val draftEventId: String? = null,
    val draftTicketId: String? = null,

    val prizeToUpdateId: String? = null,
    val prizeImageUrl: String? = null,
    val ticketToUpdateId: String? = null,
    val ticketImageUrl: String? = null,
    val eventToEditId: String? = null,
    val eventImageUrl: String? = null,

    val isUpdatePrizeDialogVisible: Boolean = false,
    val isUpdateTicketDialogVisible: Boolean = false,
    val isEditEventDialogVisible: Boolean = false,

    val prizeToDeleteId: String? = null,
    val ticketToDeleteId: String? = null,
    val eventToDeleteId: String? = null,
    val deleteMessage: String? = null,

    var isFeatureEventDialogVisible: Boolean = false,
    var isDeletePrizeDialogVisible: Boolean = false,
    var isDeleteTicketConfirmDialogVisible: Boolean = false,
    var isDeleteEventConfirmDialogVisible: Boolean = false,

    val eventImageMap: Map<String, String> = emptyMap(),
    val ticketImageMap: Map<String, String> = emptyMap(),
    val prizeImageMap: Map<String, String> = emptyMap(),

    val pendingAssignmentsPerTicket: Map<String, Int> = emptyMap(),
    val pendingAssignmentsForTicket: Map<String, List<PurchaseUiModel>> = emptyMap(),
    val pendingAssignmentsPerEvent: Map<String, Int> = emptyMap(),

    val ticketToAdjustId: String? = null,
    val ticketToAssignId: String? = null,
    val isAdjustDialogVisible: Boolean = false,
    val isAssignDialogVisible: Boolean = false,

    val allocationsPerTicket: Map<String, List<Allocation>> = emptyMap()
)